import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fb1b7dbc")

_pushScopeId("data-v-fb1b7dbc")
const _hoisted_1 = { class: "discount-line" }
const _hoisted_2 = { class: "discount column-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "title" }, "#ID", -1)
const _hoisted_4 = { class: "value" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_6 = { class: "discount column-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Platnost (Od)", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_10 = { class: "discount column-3" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Platnost (Do)", -1)
const _hoisted_12 = { class: "value" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_14 = { class: "discount column-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Jazyky", -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_18 = { class: "discount column-5" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Platformy", -1)
const _hoisted_20 = { class: "value" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_22 = { class: "discount-line" }
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("hr", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.alertItem.id), 1),
        _hoisted_5
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("p", _hoisted_8, _toDisplayString(_ctx.alertItem.from.toLocaleString()), 1),
        _hoisted_9
      ]),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode("p", _hoisted_12, _toDisplayString(_ctx.alertItem.to.toLocaleString()), 1),
        _hoisted_13
      ]),
      _createVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode("p", _hoisted_16, _toDisplayString(_ctx.getLanguages().toString().toUpperCase()), 1),
        _hoisted_17
      ]),
      _createVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode("p", _hoisted_20, _toDisplayString(_ctx.alertItem.platforms.toString()), 1),
        _hoisted_21
      ])
    ]),
    _createVNode("div", _hoisted_22, [
      _hoisted_23,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getAlertMessages(), (message) => {
        return (_openBlock(), _createBlock("div", {
          class: "discount column-1",
          key: message
        }, [
          _createVNode("p", _hoisted_24, "Jazyk: " + _toDisplayString(message.lang.toUpperCase()), 1),
          _createVNode("p", _hoisted_25, _toDisplayString(message.text), 1),
          _hoisted_26,
          _createVNode("button", {
            class: "button-edit",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editAlert(_ctx.alertItem)))
          }, "Upravit"),
          _hoisted_27,
          _createVNode("button", {
            class: "button-delete",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeAlert(_ctx.alertItem)))
          }, "Smazat")
        ]))
      }), 128))
    ]),
    _hoisted_28
  ], 64))
})